<template>
  <div>
    <el-table
      v-loading="loading"
      :data="discounts"
      style="width: 100%"
      :show-header="true"
      @cell-click="clickCell"
    >
      <el-table-column label="Гарчиг" prop="title_mon"></el-table-column>
      <el-table-column label="Channel" prop="channel"></el-table-column>
      <el-table-column label="Хөнгөлөлтийн код">
        <template slot-scope="scope">
          <div>
            <strong>{{ scope.row.discount_code }}</strong>
          </div>
          <div>
            <span class="secondary">{{ scope.row.desc_mon }} </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Төлөв">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status === 'active'"
            type="success"
            effect="dark"
            >Active</el-tag
          >
          <el-tag
            v-else-if="scope.row.status === 'expired'"
            type="info"
            effect="dark"
            >Expired</el-tag
          >
          <el-tag v-else type="warning" effect="dark">{{
            scope.row.status
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Хэрэглээ хязгаар">
        <template slot-scope="scope">
          <div v-if="scope.row.usage_limit">
            {{ scope.row.usage_limit }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Эхлэх - дуусах огноо">
        <template slot-scope="scope">
          <div v-if="scope.row.end_date">
            {{ formatDate(scope.row.start_date) }} -
            {{ formatDate(scope.row.end_date) }}
          </div>
          <div v-else>{{ formatDate(scope.row.start_date) }} - с эхэлнэ</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import helper from '../../../helpers/helper'
export default {
  name: 'discountTable',
  props: ['discounts', 'loading'],
  data () {
    return {
      page: 1
    }
  },
  watch: {
    currentPage (value) {
      this.page = value
    }
  },
  methods: {
    clickCell (row) {
      this.$router.push({
        name: 'detailDiscount',
        params: {
          id: row.id
        }
      })
    },
    formatDate (val) {
      return helper.formatDate(val, 'YYYY/MM/DD')
    }
  }
}
</script>
